import React, { useCallback } from 'react';

import { SuggestAsync, SuggestAsyncProps } from '.';
import { api } from '../../../../helpers/client';
import { MainItem, SubitemItem } from './menu/index.styles';

type IOrganizationSuggestProps<T> = Omit<SuggestAsyncProps<T>, 'getOptions' | 'mapperOption' | 'optionRender'> & {
    count: number;
    maxLength: number;
    kladrId?: string;
};

export function FormOrganizationSuggest(props: IOrganizationSuggestProps<Dadata.OrganizationSuggestItem>) {
    const { count, kladrId, ...other } = props;

    const getOptions = useCallback(
        (value) => {
            return api.organization(count, value, kladrId ? { locations_boost: [{ kladr_id: kladrId }] } : undefined);
        },
        [count, kladrId],
    );

    return (
        <SuggestAsync<Dadata.OrganizationSuggestItem>
            {...other}
            showManualButton
            getOptions={getOptions}
            onlyRus
            clearable={Boolean(props?.input?.value)}
            mapperOption={(option) => ({ name: props?.input?.name || '', value: option.value, option })}
            optionRender={(mapped) => (
                <div>
                    <MainItem>{mapped.option?.value}</MainItem>
                    <SubitemItem>
                        {[
                            mapped.option?.data?.address?.unrestricted_value || '',
                            mapped.option?.data?.inn ? `ИНН ${mapped.option?.data?.inn}` : '',
                        ]
                            .filter((c) => c)
                            .join(', ')}
                    </SubitemItem>
                </div>
            )}
        />
    );
}
